"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fragments_1 = require("../fragments");
const notifi_axios_utils_1 = require("@notifi-network/notifi-axios-utils");
const DEPENDENCIES = [...fragments_1.userFragmentDependencies, fragments_1.userFragment];
const MUTATION = `
mutation completeLogInByTransaction(
  $walletAddress: String!,
  $walletBlockchain: WalletBlockchain!,
  $dappAddress: String!,
  $randomUuid: String!,
  $transactionSignature: String!
) {
  completeLogInByTransaction(completeLogInByTransactionInput: {
    walletAddress: $walletAddress
    walletBlockchain: $walletBlockchain
    dappAddress: $dappAddress
    randomUuid: $randomUuid
    transactionSignature: $transactionSignature
  }) {
    ...userFragment
  }
}
`.trim();
const completeLogInByTransactionImpl = (0, notifi_axios_utils_1.makeRequest)((0, notifi_axios_utils_1.collectDependencies)(...DEPENDENCIES, MUTATION), 'completeLogInByTransaction');
exports.default = completeLogInByTransactionImpl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tcGxldGVMb2dJbkJ5VHJhbnNhY3Rpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9saWIvbXV0YXRpb25zL2NvbXBsZXRlTG9nSW5CeVRyYW5zYWN0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsNENBQXNFO0FBQ3RFLDJFQUc0QztBQU01QyxNQUFNLFlBQVksR0FBRyxDQUFDLEdBQUcsb0NBQXdCLEVBQUUsd0JBQVksQ0FBQyxDQUFDO0FBRWpFLE1BQU0sUUFBUSxHQUFHOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FrQmhCLENBQUMsSUFBSSxFQUFFLENBQUM7QUFFVCxNQUFNLDhCQUE4QixHQUFHLElBQUEsZ0NBQVcsRUFHaEQsSUFBQSx3Q0FBbUIsRUFBQyxHQUFHLFlBQVksRUFBRSxRQUFRLENBQUMsRUFBRSw0QkFBNEIsQ0FBQyxDQUFDO0FBRWhGLGtCQUFlLDhCQUE4QixDQUFDIn0=